import React, { useEffect, useState } from "react";
import Colors from "../../useclass/colors";
import { API_BASE_URL } from "../../config";
import axios from "axios";
import useIsMountedRef from "../../utils/mountedRef";
import BadgeNouveau from "../texts/BadgeNouveau";
import { OTHERS } from "../../views/Home";
import { DMTG } from "../../views/Home";
import { DEACTIVATED } from "../../views/Home";
import { NEWSIMIDS } from "../../views/Home";
import { NEWSUBCATEGORIES } from "../../views/Home";
import { useHistory, useLocation } from "react-router-dom";


const Categoriesblock = (props) => {
  const history = useHistory();
  const location = useLocation();
  const dmtg = DMTG;
  const others = OTHERS;
  const deactivated = DEACTIVATED;
  const newSimIds = NEWSIMIDS;
  const newSubCategories = NEWSUBCATEGORIES;
  const isImmobilierCompact = Boolean(props.compactLayout);
  const visibleSimulateurs = (props.body || []).filter((item) => !deactivated.includes(Number(item.id)));
  const isContratDeMariageSubcategory = props.title === "Contrat de mariage";
  
  const styles = {
    container: {
      width: "100%",
      marginBottom: 50,
    },
    containerTitle: {
      color: Colors.primaryBlue,
      width: "90%",
      fontSize: 22,
      marginLeft: "auto",
      marginRight: "auto",
      marginTop: 10,
      marginBottom: 10,
    },
    containerBody: {
      width: isImmobilierCompact ? "94%" : "88%",
      marginLeft: isImmobilierCompact ? 32 : "auto",
      marginRight: isImmobilierCompact ? 0 : "auto",
    },
    containerItem: {
      display: "grid",
      gridTemplateColumns: isImmobilierCompact ? "24px 10px 1fr" : "32px 12px 1fr",
      marginTop: 15,
      marginBottom: 15,
      lineHeight: 1.5,
      alignItems: "center",
    },
    bar: {
      backgroundColor: Colors.primaryBlue,
      width: 2,
      height: isImmobilierCompact ? 34 : 30,
      marginTop: "auto",
      marginBottom: "auto",
    },
    star: {
      marginTop: "auto",
      marginBottom: "auto",
      cursor: "pointer",
    },
    bodyText: {
      marginTop: "auto",
      marginBottom: "auto",
      cursor: "pointer",
      fontSize: isImmobilierCompact ? 17 : 16,
    },
  };

  const isMountedRef = useIsMountedRef();
  const [allFavoris, setAllFavoris] = useState(localStorage.getItem("favoris"));

  useEffect(() => {
    if (allFavoris !== null && allFavoris.length > 0) {
      try {
        setAllFavoris(JSON.parse(allFavoris));
      } catch (e) {}
    }
  }, [isMountedRef]);

  const getCategoryBasePath = () => {
    const match = location.pathname.match(/^\/categorie\/[^/]+/);
    return match ? match[0] : location.pathname;
  };

  function returnStar(item) {
    if (allFavoris == null) {
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20.847"
          height="19.011"
          preserveAspectRatio="xMidYMid meet"
          viewBox="0 0 512 512"
        >
          <path
            fill="none"
            stroke="#5E91B6"
            strokeLinejoin="round"
            strokeWidth="32"
            d="M480 208H308L256 48l-52 160H32l140 96l-54 160l138-100l138 100l-54-160Z"
          />
        </svg>
      );
    }
    if (allFavoris.hasOwnProperty(item.id)) {
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20.847"
          height="19.011"
          preserveAspectRatio="xMidYMid meet"
          viewBox="0 0 512 512"
        >
          <path
            fill="#5E91B6"
            d="M394 480a16 16 0 0 1-9.39-3L256 383.76L127.39 477a16 16 0 0 1-24.55-18.08L153 310.35L23 221.2a16 16 0 0 1 9-29.2h160.38l48.4-148.95a16 16 0 0 1 30.44 0l48.4 149H480a16 16 0 0 1 9.05 29.2L359 310.35l50.13 148.53A16 16 0 0 1 394 480Z"
          />
        </svg>
      );
    } else {
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20.847"
          height="19.011"
          preserveAspectRatio="xMidYMid meet"
          viewBox="0 0 512 512"
        >
          <path
            fill="none"
            stroke="#5E91B6"
            strokeLinejoin="round"
            strokeWidth="32"
            d="M480 208H308L256 48l-52 160H32l140 96l-54 160l138-100l138 100l-54-160Z"
          />
        </svg>
      );
    }
  }

  function onClickFavoris(id) {
    var config = {
      method: "get",
      url: `${API_BASE_URL}/favoris/${id}`,
      headers: {
        "Content-Type": "application/json",
        Authorization: JSON.parse(localStorage.getItem("user"))?.jwt,
      },
    };
    axios(config).then((response) => {
      if (response.status === 200 && response.data != null) {
        localStorage.setItem("favoris", response.data);
        if (response.data !== null) setAllFavoris(JSON.parse(response.data));
        else setAllFavoris(response.data);
      }
    })
    .catch((error) => {
      if (error.response?.status === 401 && error.response.data != null) {
        if (error.response.data.error == "Other_user_connected" ) {
          localStorage.removeItem("user")
          localStorage.setItem("other_user_connected", "other_user_connected")
          window.location.href = "/login"
        }
      }
    
    });
  }

    //   // permet de supprimer l'affichage des simulateurs que l'on souhaite
    //   for ( var i = 0 ; i < props.body.length ; i++) {
    //     if (props.body[i].id == 112) {
    //         props.body.splice(i, 1);
    //     }
    // }

  return (
    <div style={styles.container}>
      {!props.hideTitle ? (
        <div style={styles.containerTitle}>
          {props.title}
          {newSubCategories.includes(Number(props.subCatId)) && <BadgeNouveau />}
        </div>
      ) : null}

      <div style={styles.containerBody}>
        {visibleSimulateurs.map((item) => (
          <div key={item.id} style={styles.containerItem}>
            <div style={styles.star} onClick={(e) => onClickFavoris(item.id)}>
              {returnStar(item)}
            </div>
            <div style={styles.bar}></div>
            <div
              className="badge-hover-parent"
              style={styles.bodyText}
              onClick={(e) => {
                const basePath = getCategoryBasePath();
                if (dmtg.includes(Number(item.id))) {
                  history.push(`${basePath}/dmtg/${item.id}`);
                } else if (others.includes(Number(item.id))) {
                  history.push(`${basePath}/others/${item.id}`);
                } else if (!deactivated.includes(Number(item.id))) {
                  const shouldOpen76Bis = Number(item.id) === 76 && isContratDeMariageSubcategory;
                  history.push(`${basePath}/simulateur/${item.id}${shouldOpen76Bis ? "#bis" : ""}`);
                }
              }}
            >
              {item.id === 52 ? "Déclaration de succession (Émoluments de DS et calcul de DMTG 1er et 2e décès)" 
              : item.id === 55 ? "DMTG - Succession 1 à 9 personnes (1er et 2e décès)" 
              : item.id === 84 ? "Prêts aux particuliers garantis par une HLPD (Hypothèque légale de prêteur de denier) et/ou une hypothèque conventionnelle (HC) et/ou un cautionnement (garanti ou non par une HC)" 
              : item.id === 85 ? "Prêts aux particuliers à l'accession à la propriété (PAS, PSI, PTZ+) ou prêts à la construction garantis par une hypothèque conventionnelle (HC) et/ou un cautionnement (garanti ou non par une HC)" 
              : item.id === 92 ? "Prêts aux professionnels garantis par une HLPD (Hypothèque légale de prêteur de denier) et/ou une hypothèque conventionnelle (HC) et/ou un cautionnement (garanti ou non par une HC)" 
              : item.id === 76 && !isContratDeMariageSubcategory ? "Changement de régime matrimonial avec apport ou biens déclarés (biens propres/personnels ou biens détenus en indivision)" 
              : item.id === 76 && isContratDeMariageSubcategory ? "Contrat de mariage avec apport ou biens déclarés (biens propres/personnels ou biens détenus en indivision)" 
              : item.name}
              {newSimIds.includes(item.id) && <BadgeNouveau />}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Categoriesblock;
